module.exports = __webpack_public_path__ + "img/paia-manual.f7acaf51.svg";